import * as React from 'react';
import { SVGProps } from 'react';

const IconCancelSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0zM9.571 6a3.571 3.571 0 0 1-5.54 2.98L8.98 4.03c.374.565.591 1.242.591 1.97zm-6.55 1.97L7.97 3.02a3.571 3.571 0 0 0-4.95 4.95z"
    />
  </svg>
);
export default IconCancelSizeXs;
